<!-- eslint-disable vue/valid-template-root -->
<template>
  <TabbedZoneOfRelevanceTemplate :section-title="sectionTitle" :zor-tabs="zorTabs" :kill-switches="killSwitches" />
</template>

<script setup>
import { computed } from 'vue';
import TabbedZoneOfRelevanceTemplate from '@nuxt-common/canvas-aem/app/components/zoneOfRelevance/TabbedZoneOfRelevance';
import { userInfo } from '@/utils/userInfo';
import { useEnvProps } from '@/stores/envProps';
import { ZOR_TAB_SECTION_TITLES } from './constants';

defineProps({
  zorTabs: {
    type: Array,
    default: () => [],
  },
});

const envPropsStore = useEnvProps();

const isSignedIn = userInfo.isSignedIn();
const userStatus = isSignedIn ? 'signedIn' : 'notSignedIn';

const brand = computed(() => envPropsStore?.envProps?.BRAND);
const sectionTitle = computed(() => ZOR_TAB_SECTION_TITLES[brand?.value]?.[userStatus] || '');
const killSwitches = computed(() => envPropsStore.envProps?.meta?.properties);
</script>
